import {AfterViewInit, Component} from '@angular/core';
import { Chart } from 'angular-highcharts';
import {TransactionService} from '../../../services/transaction.service';
import {DisplayFieldPipe} from '../../pipes/displayField.pipe';
import * as _ from 'lodash';
import {Router} from '@angular/router';
import {HighchartsService} from '../../../services/highcharts.service';
import {DatesService} from '../../../services/dates.service';
import {Title} from '@angular/platform-browser';

@Component({
    selector: 'app-transactions-dynamics',
    templateUrl: './transactions-dynamics.component.html',
    styleUrls: ['./transactions-dynamics.component.scss'],
    providers: [HighchartsService, DatesService]
})
export class TransactionsDynamicsComponent implements AfterViewInit {

    companies: Array<any> = [];

    minDate:   Date = new Date(2000, 1, 1);
    startYear: Date = new Date(2010, 1, 1);

    periods: Array<any> = [{
        value: HighchartsService.DRILLDOWN_DAY,
        text: 'Daily'
    }, {
        value: HighchartsService.DRILLDOWN_WEEK,
        text: 'Weekly'
    }, {
        value: HighchartsService.DRILLDOWN_MONTH,
        text: 'Monthly'
    }, {
        value: HighchartsService.DRILLDOWN_YEAR,
        text: 'Yearly'
    }];

    filters: any = {
        aggrigatedBy: HighchartsService.DRILLDOWN_YEAR,
        CO1_ID: [],
        ED1_MODIFIED_ON_FROM: null,
        ED1_MODIFIED_ON_TO: null
    };

    ediTypes:  Array<object>  = [];
    chart: Chart;

    constructor(
        private transactionService: TransactionService,
        private highchartsService: HighchartsService,
        private datesService: DatesService,
        private router: Router,
        private title: Title
    ) {
        this.title.setTitle('EDI - Transactions');
    }

    ngAfterViewInit() {
        this.transactionService.preloadData().subscribe( res => {
            this.companies = res.companies;
            this.ediTypes  = res.ediTypes;

            this.chart = new Chart({
                chart: {
                    type: 'spline'
                },
                title: {
                    text: 'EDI Transactions'
                },
                xAxis: {
                    title: {
                        text: 'Timeline'
                    },
                    type: 'datetime'
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: 'Number of transactions'
                    }
                },
                exporting: {
                    enabled: false
                }
            });
            this.onSubmit();
        });
    }

    loadChartData(params: any = null) {

        const series = [];
        if (params['CO1_ID'] && params['CO1_ID'].length ) {
            params['CO1_ID'].forEach( CO1_ID => {
                const tmp = _.clone(params);
                tmp['CO1_ID'] = CO1_ID;
                series.push(tmp);
            });
        } else {
            series.push(params);
        }

        this.transactionService.getSeries(series).subscribe(data => {

            this.highchartsService.removeAllSeries(this.chart);

            const me = this;
            const displayFieldPipe = new DisplayFieldPipe();

            data.serie.forEach( serieData => {

                if (serieData.data.length ) {
                    let name = '';
                    if (serieData['CO1_ID']) {
                        name = displayFieldPipe.transform(serieData['CO1_ID'], 'CO1_ID', 'CO1_NAME', me.companies);
                    } else {
                        name = serieData.data[0].name;
                    }
                    me.chart.addSerie({
                        name: name,
                        data: serieData.data[0].data
                    });
                }

            });
        });
    }

    onSubmit() {

        const filters = _.clone(this.filters);

        if (filters['CO1_ID'] && filters['CO1_ID'].length) {
            filters['groupBy'] = 'CO1_ID';
        }

        if (filters['ED1_MODIFIED_ON_FROM']) {
            filters['ED1_MODIFIED_ON_FROM'] = this.datesService.format(filters['ED1_MODIFIED_ON_FROM']);
        }
        if (filters['ED1_MODIFIED_ON_TO']) {
            filters['ED1_MODIFIED_ON_TO'] = this.datesService.format(filters['ED1_MODIFIED_ON_TO'], '23:59:59');
        }

        this.loadChartData(filters);
    }

    onCancel(): void {
        this.router.navigate(['/transactions']);
    }
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/transactions/transactions-dynamics/transactions-dynamics.component.ts